import React from 'react';

const NusmaServicesSection = ({ 
  onNavigateToContact = () => {} 
}) => {
  const services = [
    {
      id: 1,
      title: "Implementación y Configuración",
      description: "Configuramos nuestras soluciones de IA según las necesidades específicas de tu organización",
      features: [
        "Análisis de requerimientos",
        "Configuración personalizada",
        "Migración de datos",
        "Pruebas de integración"
      ],
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
          <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        </svg>
      ),
      color: "red"
    },
    {
      id: 2,
      title: "Capacitación y Soporte",
      description: "Entrenamos a tu equipo y brindamos soporte continuo para maximizar el valor de la inversión",
      features: [
        "Capacitación del equipo",
        "Documentación completa",
        "Soporte técnico 24/7",
        "Actualizaciones regulares"
      ],
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 14l9-5-9-5-9 5 9 5z"/>
          <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
        </svg>
      ),
      color: "gray"
    },
    {
      id: 3,
      title: "Consultoría Especializada",
      description: "Asesoramiento experto en cumplimiento normativo y mejores prácticas de seguridad",
      features: [
        "Evaluación de madurez",
        "Roadmap de cumplimiento",
        "Mejores prácticas",
        "Auditorías especializadas"
      ],
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
        </svg>
      ),
      color: "red-dark"
    },
    {
      id: 4,
      title: "Integración de Sistemas",
      description: "Conectamos nuestras soluciones con tu infraestructura tecnológica existente",
      features: [
        "APIs robustas",
        "Conectores predefinidos",
        "Sincronización en tiempo real",
        "Arquitectura escalable"
      ],
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
        </svg>
      ),
      color: "red-light"
    },
    {
      id: 5,
      title: "Auditorías Técnicas Especializadas",
      description: "Realizamos auditorías técnicas detalladas para identificar vulnerabilidades y oportunidades de mejora en seguridad de la información",
      features: [
        "Auditorías de penetración",
        "Análisis de vulnerabilidades",
        "Evaluación de controles técnicos",
        "Reportes detallados de riesgos"
      ],
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 7.5L16 12 12 16.5m-2-9L8 12l2 4.5m8-9l-2 4.5M8 12l2-4.5m10 6L16 12l2-4.5M8 12l-2-4.5m0 9L8 12l2-4.5m10 6l-2-4.5"/>
        </svg>
      ),
      color: "red"
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      red: {
        bg: "bg-red-950",
        icon: "bg-red-900 text-red-300",
        accent: "text-red-500",
        border: "border-red-800"
      },
      gray: {
        bg: "bg-gray-900",
        icon: "bg-gray-800 text-gray-300",
        accent: "text-gray-400",
        border: "border-gray-700"
      },
      "red-dark": {
        bg: "bg-red-900",
        icon: "bg-red-800 text-red-200",
        accent: "text-red-400",
        border: "border-red-700"
      },
      "red-light": {
        bg: "bg-red-800",
        icon: "bg-red-700 text-red-100",
        accent: "text-red-300",
        border: "border-red-600"
      }
    };
    return colors[color];
  };

  return (
    <section className="py-20 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Servicios Profesionales
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Acompañamos a tu organización en cada etapa del proceso de implementación 
            y adopción de nuestras soluciones de IA para cumplimiento normativo.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service) => {
            const colorClasses = getColorClasses(service.color);
            return (
              <div
                key={service.id}
                className={`${colorClasses.bg} rounded-3xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border ${colorClasses.border}`}
              >
                {/* Service Header */}
                <div className="flex items-start mb-6">
                  <div className={`w-12 h-12 rounded-2xl ${colorClasses.icon} flex items-center justify-center mr-4 shadow-sm`}>
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                    <p className="text-gray-400">{service.description}</p>
                  </div>
                </div>

                {/* Features */}
                <div className="space-y-3 mb-6">
                  {service.features.map((feature, index) => (
                    <div key={index} className="flex items-center">
                      <div className={`w-1.5 h-1.5 rounded-full ${colorClasses.accent.replace('text-', 'bg-')} mr-3`}></div>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <button
                  onClick={onNavigateToContact}
                  className={`w-full ${colorClasses.accent} font-semibold py-3 px-6 rounded-xl border-2 ${colorClasses.accent.replace('text-', 'border-')} hover:bg-gray-800 transition-all duration-200`}
                >
                  Consultar Servicio
                </button>
              </div>
            );
          })}
        </div>

        {/* Process Section */}
        <div className="bg-gray-900 rounded-3xl p-12 shadow-xl border border-gray-800">
          <h3 className="text-2xl font-bold text-white text-center mb-12">
            Nuestro Proceso de Implementación
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: "01", title: "Análisis", desc: "Evaluamos tus necesidades y requerimientos específicos" },
              { step: "02", title: "Diseño", desc: "Creamos una solución personalizada para tu organización" },
              { step: "03", title: "Implementación", desc: "Desplegamos y configuramos la solución en tu entorno" },
              { step: "04", title: "Soporte", desc: "Brindamos capacitación y soporte continuo post-implementación" }
            ].map((phase, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-900 rounded-2xl flex items-center justify-center text-white font-bold text-lg mx-auto mb-4 shadow-lg">
                  {phase.step}
                </div>
                <h4 className="text-lg font-semibold text-white mb-2">{phase.title}</h4>
                <p className="text-gray-400 text-sm">{phase.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NusmaServicesSection;